// extracted by mini-css-extract-plugin
export default {"header":"Header_header__THBFg","sidebarToggle":"Header_sidebarToggle__ECL3G","supportRequestLink":"Header_supportRequestLink__39wSY"};